import classNames from 'classnames';

import { RENEWAL_ILLUSTRATIONS } from '../../utils/renewal';
import BrokenCard from '../../images/renewal-broken-card.png';
import ScaredCat from '../../images/renewal-scared-cat.png';
import TakeBackBagClosets from '../../images/renewal-take-back-bag-closets.png';
import UnlimitedWordmark from '../../images/renewal-unlimited-wordmark.svg';

import './RenewalIllustration.scss';

const SOURCES = {
  [RENEWAL_ILLUSTRATIONS.BROKEN_CARD]: BrokenCard,
  [RENEWAL_ILLUSTRATIONS.CAT]: ScaredCat,
  [RENEWAL_ILLUSTRATIONS.CLOSETS]: TakeBackBagClosets,
};

/**
 * The Unlimited wordmark from the renewal designs (Figma "Frame 2608456").
 *
 * @return {JSX.Element}
 */
export const RenewalWordmark = ({ className }) => (
  <img
    src={UnlimitedWordmark}
    alt="Trashie Unlimited"
    width="130.223"
    height="28"
    className={classNames('RenewalWordmark', className)}
  />
);

/**
 * Decorative renewal artwork, positioned per slot as in the Figma.
 *
 * @param {object} props
 * @param {string} props.illustration - RENEWAL_ILLUSTRATIONS value
 * @param {string} props.slot - 'sheet' | 'banner'
 * @return {JSX.Element|null}
 */
const RenewalIllustration = ({ illustration, slot }) => {
  const src = SOURCES[illustration];
  if (!src) return null;
  const modifier = `RenewalIllustration--${illustration.toLowerCase()}`;
  const image = (
    <img
      src={src}
      alt=""
      aria-hidden="true"
      className={classNames('RenewalIllustration', `RenewalIllustration--${slot}`, modifier)}
    />
  );
  // The banner crops the art inside a fixed-ratio frame that overhangs the card's
  // padding, as in the Figma; the sheet positions it inside its own pink panel.
  if (slot !== 'banner') return image;
  return (
    <div className={classNames('RenewalIllustration__frame', `${modifier}-frame`)} aria-hidden="true">
      {image}
    </div>
  );
};

export default RenewalIllustration;
